export default __webpack_public_path__ + "static/media/deez_1000_1000.3a28e2c9.png";